export function resolveNotOrderableReason (reason) {
  const reasonKey = reason || ''
  if (reasonKey.startsWith('shadow_')) {
    const baseReason = reasonKey.substring('shadow_'.length)
    return `Shadow-Modus: ${resolveNotOrderableReason(baseReason)}`
  }

  const reasonMap = {
    UnknownProduct: 'Produkt im System nicht bekannt.',
    product_not_found: 'Produkt im System nicht bekannt.',
    unknown: 'Bestellbarkeit konnte nicht eindeutig bestimmt werden.',
    eligibility_decision_unavailable: 'Bestellbarkeit konnte nicht geprueft werden (Eligibility-Entscheid fehlt).',
    eligibility_service_error: 'Bestellbarkeit konnte nicht geprueft werden (Eligibility-Service-Fehler).',
    no_matching_rule: 'Fuer diesen Artikel liegt keine passende Berechtigungsregel vor.',
    rule_allowed: 'Die Berechtigungsregel erlaubt die Bestellung dieses Artikels.',
    rule_denied: 'Die Berechtigungsregel verbietet die Bestellung dieses Artikels.',
    ar_products_not_allowed: 'AR-Produkte sind fuer diesen Kontext nicht bestellbar.',
    missing_injection_authorization: 'Fehlende Injektionsberechtigung fuer diesen Artikel.',
    delivery_index_too_low: 'Der Lieferindex des Artikels erfuellt die Mindestanforderung nicht.',
    missing_product_external_id: 'Die Produkt-ExternalId fehlt in der Anfrage.',
    missing_location_id: 'Die Standort-ID fehlt fuer die Bestellbarkeitspruefung.',
    mode_off: 'Bestellbarkeitspruefung ist deaktiviert (Mode Off).',
    fallback_allow_by_default: 'Bestellbarkeit konnte nicht geprueft werden; Fallback erlaubt die Bestellung standardmaessig.',
    fallback_deny_by_default: 'Bestellbarkeit konnte nicht geprueft werden; Fallback verbietet die Bestellung standardmaessig.'
  }

  return reasonMap[reasonKey] || `Nicht bestellbar (Grund: ${reasonKey || 'unbekannt'})`
}

export default {
  resolveNotOrderableReason
}
